import { useGetCookie } from 'cookies-next/client';

export const useLoggedIn = () => {
  // https://clerk.com/docs/how-clerk-works/cookies
  const clientUAT = useGetCookie()('__client_uat');
  return clientUAT && clientUAT != "0"
}
